import {Component} from "react";
import Link from "../../Link/Link";

export default class FooterLink extends Component {
  render() {
    const { acessLinks } = this.props;

    return (
      <>
        {acessLinks?.map((link, i) => (
            <Link
            noIcon
            inverted
            link={link.urlLink}
            key={i}
            text={link.textLink}
            className={"footer__links"}
            target={link.linkTarget}
            />
          ))}
      </>
    );
  }
}
